{
  "name": "idhub",
  "version": "2.1.1",
  "scripts": {
    "ng": "ng",
    "icons:sprite": "node tools/build-sprite.mjs",
    "themes:generate": "node scripts/themes/generate-themes.mjs",
    "prepare:assets": "yarn icons:sprite && yarn themes:generate",
    "prestart": "yarn prepare:assets",
    "start": "ng serve --host 0.0.0.0 --port 4444",
    "prebuild": "yarn prepare:assets",
    "build": "ng build",
    "build:development": "ng build --configuration development",
    "prebuild:production": "yarn prepare:assets",
    "build:production": "ng build --configuration production",
    "icons:optimize": "svgo -f src/assets/icons --config=.svgo.config.cjs",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "format": "prettier --write --config ./.prettierrc src/**/*{.ts,.scss,.html}",
    "format:check": "prettier --check .",
    "lint:scss": "stylelint 'src/**/**.scss'",
    "lint:ts": "tsc --noEmit && eslint 'src/**/**.ts'"
  },
  "husky": {
    "hooks": {
      "pre-commit": "npm --no-git-tag-version version patch && git add package.json"
    }
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.1.3",
    "@angular/aria": "22.1.3",
    "@angular/cdk": "22",
    "@angular/common": "22.1.3",
    "@angular/compiler": "22.1.3",
    "@angular/core": "22.1.3",
    "@angular/forms": "22.1.3",
    "@angular/localize": "22.1.3",
    "@angular/platform-browser": "22.1.3",
    "@angular/platform-browser-dynamic": "22.1.3",
    "@angular/pwa": "22",
    "@angular/router": "22.1.3",
    "@angular/service-worker": "22.1.3",
    "@assecods/design-system": "^1.4.35",
    "@assecods/ng-design-system": "^21.1.7",
    "@ng-bootstrap/ng-bootstrap": "21",
    "@ng-select/ng-select": "23",
    "@ngx-translate/core": "^16.0.3",
    "@ngx-translate/http-loader": "^16.0.0",
    "@popperjs/core": "^2.11.8",
    "@types/lodash-es": "^4.17.9",
    "@types/qrcode": "^1.5.2",
    "bootstrap": "^5.3.0",
    "date-fns": "4",
    "lodash-es": "4.17.23",
    "ngx-device-detector": "12",
    "ngx-mask": "15.1.5",
    "rxjs": "^7.8",
    "simplebar": "^6.3.3",
    "simplebar-angular": "^3.3.2",
    "simplebar-core": "^1.3.2",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22",
    "@angular-devkit/core": "22",
    "@angular-devkit/schematics": "22",
    "@angular-eslint/builder": "22.1.0",
    "@angular-eslint/eslint-plugin": "22.1.0",
    "@angular-eslint/eslint-plugin-template": "22.1.0",
    "@angular-eslint/schematics": "22.1.0",
    "@angular-eslint/template-parser": "22.1.0",
    "@angular/cli": "22.1.5",
    "@angular/compiler-cli": "22.1.3",
    "@types/jasmine": "~3.6.0",
    "@types/jest": "^29.5.12",
    "@types/node": "^20.10.5",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "eslint": "9.26.0",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-airbnb-angular": "^1.0.0",
    "eslint-config-airbnb-typescript": "^17.1.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-angular": "^4.1.0",
    "eslint-plugin-import": "^2.22.1",
    "eslint-plugin-jsx-a11y": "^6.4.1",
    "eslint-plugin-prettier": "^5.1.2",
    "husky": "^9.0.11",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "jest": "^29.7.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "prettier": "^3.1.1",
    "protractor": "~7.0.0",
    "stylelint": "^13.13.1",
    "stylelint-config-sass-guidelines": "^8.0.0",
    "svgo": "^4.0.0",
    "svgstore": "^3.0.1",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "tslint-config-prettier": "^1.18.0",
    "typescript": "~6.0.3"
  },
  "engines": {
    "node": ">=20.19.0",
    "yarn": ">=4.5",
    "npm": "Please use yarn instead of NPM to install dependencies"
  },
  "packageManager": "yarn@4.5.0"
}
